(function () {
  angular
    .module('specsguardApp')
    .controller('sgTableCtrl', sgTableCtrl);

  sgTableCtrl.$inject = ['Labels', '$scope', '$rootScope'];

  function sgTableCtrl (Labels, $scope, $rootScope) {
    const vm = this;
    vm.LABELS = Labels;
    vm.sortActive = {};
    vm.direction = null;

    vm.$onInit = () => {
      // DO we get a default for the sorting?
      if (vm.defaultSort) {
        vm.sortActive.componentName = vm.defaultSort;
      }

      vm.hideKey = angular.isDefined(vm.hideKey) ? vm.hideKey : 'hide';
      vm.combineFilters = angular.isDefined(vm.combineFilters) ? vm.combineFilters : true;
      vm.bulkModeStatus = angular.isDefined(vm.bulkMode) ? !vm.bulkMode.enabled : true;
      vm.totalFilteredResults = vm.data.length;
      vm.page = vm.pagination && vm.pagination.startPage || 0;

      /**
       * When columnFilters is enabled, use the defined columns object to create the menu
       * 1. Items with the defined property will have a selected checkbox (default columns)
       * 2. Remaining items will be displayed with an unchecked checkbox
       *
       * By reloading the filters we can add an additional property to maintain the
       * visibility of the columns (toggled TRUE|ON by default)
       */
      if (angular.isDefined(vm.columnFilters) && vm.columnFilters.enabled) {
        // are there predfined active filters?
        if (vm.columnFilters.active && vm.columnFilters.active.length) {
          for (const defaultColumnFilter of vm.columnFilters.active) {
            const preactiveColumnFilter = vm.columns.find(col => col.displayKey === defaultColumnFilter.displayKey);
            preactiveColumnFilter.value = defaultColumnFilter.value;
            preactiveColumnFilter.active = true;

            // Preselect in the interface boject
            for (const el of preactiveColumnFilter.filterData) {
              el.selected = !!preactiveColumnFilter.value.find(f => f.value === el.value);
            }
          }
        }

        vm.columnFilters.columns = angular.copy(vm.columns);
      }

      if (vm.pagination) {
        vm.resultLimit = vm.pagination.resultLimit || 10;
        calculatePaginatedResults(vm.page, vm.page + 1);
      } else {
        vm.paginatedResults = vm.data;
      }
    };


    /**
     * Apply the selected options in the column filters
     */
    vm.columnFiltersToggle = () => {
      vm.columns.forEach((column) => {
        const itemProxyToggle = vm.columnFilters.columns.find((selectedFilter) => {
          if (selectedFilter.displayKey === column.displayKey) {
            return selectedFilter.itemProxyToggle;
          }

          return false;
        });

        return column.columnFilter = itemProxyToggle;
      });
    };

    vm.getBulkStatus = () => {
      vm.bulkModeStatus = !vm.bulkModeStatus;
      return vm.bulkModeStatus ? vm.columns.unshift(vm.bulkMode.option) : vm.columns.shift();
    };

    function getShownData (data) {
      return data.filter((item) => !item.hide);
    }

    function calculatePaginatedResults (startPage, endPage, data = vm.data) {
      const sortedData = executeSort(data);

      if (!vm.pagination) {
        vm.paginatedResults = getShownData(sortedData);
        return;
      }

      vm.resultStart = startPage * vm.resultLimit;
      vm.resultEnd = endPage * vm.resultLimit;

      if (vm.resultEnd > vm.totalFilteredResults) {
        vm.resultEnd = vm.totalFilteredResults;
      }

      vm.paginatedResults = getShownData(sortedData).slice(vm.resultStart, vm.resultEnd);
      $rootScope.$broadcast('paginatedResults', vm.paginatedResults);
    }

    vm.setResultLimit = () => {
      if (vm.pagination) {
        vm.resultLimit = vm.pagination.resultLimit;
        calculatePaginatedResults(vm.page, vm.page + 1);
      }
    };

    vm.nextPage = () => {
      vm.page += 1;
      calculatePaginatedResults(vm.page, vm.page + 1);
    };

    vm.lastPage = () => {
      const lastPage = Math.ceil(getShownData(vm.data).length / vm.resultLimit);
      calculatePaginatedResults(lastPage - 1, lastPage);
      vm.page = lastPage - 1;
    };

    vm.firstPage = () => {
      calculatePaginatedResults(0, 1);
      vm.page = 0;
    };

    vm.prevPage = () => {
      vm.page -= 1;
      calculatePaginatedResults(vm.page, vm.page + 1);
    };

    $scope.$watch('$sgTableCtrl.data', () => {
      const page = vm.page; // filterDataItems overwrites vm.page
      filterDataItems();
      vm.page = page;
      calculatePaginatedResults(vm.page, vm.page + 1);
    });

    vm.handleSort = (column, columnDisplayKey) => {
      if (!column.sortable) {
        return;
      }

      const key = column.displayKey;

      vm.direction = (() => {
        if (!vm.direction) {
          return 'desc';
        } else if (vm.direction === 'desc') {
          return 'asc';
        }
        return null;
      })();

      if (vm.direction === null) {
        calculatePaginatedResults(vm.page, vm.page + 1);
        return;
      }

      /**
       * When using the same sg-filter component we need to be able
       * to differentiate between the sorted sg-filter components
      */
      if (columnDisplayKey === key) {
        const sortActiveObj = {
          column,
          componentName: key,
          type: column.type,
        };

        vm.sortActive = Object.assign({}, sortActiveObj);
      }

      const sortedData = executeSort(vm.data);

      calculatePaginatedResults(vm.page, vm.page + 1, sortedData);
    };

    function executeSort (data) {
      const key = vm.sortActive.componentName;

      if (!key) {
        return data;
      }

      return data.slice(0).sort((a, b) => {
        let aValue = a[key];
        let bValue = b[key];

        aValue = angular.isString(aValue) ? aValue.toLowerCase() : aValue;
        bValue = angular.isString(bValue) ? bValue.toLowerCase() : bValue;

        if (aValue < bValue) {
          return vm.direction === 'desc' ? -1 : 1;
        } else if (aValue > bValue) {
          return vm.direction === 'desc' ? 1 : -1;
        }
        return 0;
      });
    }

    // getFilters gets columns which are filterable (filters out display only columns)
    function getFilters (activeFilterObj = {}) {
      return vm.columns.filter((column) => {
        // set if filter is active
        if (angular.isDefined(activeFilterObj[column.headerTitle])) {
          column.active = activeFilterObj[column.headerTitle];

          vm.selectedColumn = column;
        }

        return column.type;
      });
    }

    function filterDataItems (filters = null) {

      const filterableColumns = filters || getFilters();
      vm.totalFilteredResults = 0;
      vm.page = 0;

      vm.data.forEach((item) => {
        item[vm.hideKey] = !filterableColumns.every((f) => {
          if (angular.isUndefined(f.value)) {
            return true;
          } else if (f.customFilter) {

            return f.customFilter(f, item);
          }

          return filterFunctions[f.type](f, item);
        });

        if (!item[vm.hideKey]) {
          vm.totalFilteredResults += 1;
        }
      });

      calculatePaginatedResults(vm.page, vm.page + 1);
    }

    vm.filterData = ({ activeFilterObj = {} }) => {
      if (!vm.combineFilters) {
        resetData();
      }

      vm.totalFilteredResults = 0;

      const filters = getFilters(activeFilterObj);

      if (vm.selectedColumn.preFilterFn) {
        vm.selectedColumn.preFilterFn(vm.selectedColumn);
      }

      filterDataItems(filters);

      if (vm.selectedColumn.postFilterFn) {
        vm.selectedColumn.postFilterFn(vm.selectedColumn);
      }
    };

    const resetData = () => vm.data.forEach((item) => item[vm.hideKey] = false );

    const filterFunctions = {
      string: (filter, item) => {
        if (typeof item[filter.displayKey] !== 'undefined' && angular.isDefined(item[filter.displayKey])) {
          return item[filter.displayKey].toString().toLowerCase().includes(filter.value.toLowerCase());
        }
      },
      multiSelect: (filter, item) =>
        filter.value
          .map((filterItem) => String(filterItem[filter.optionValueKey]).toLowerCase())
          .includes(String(item[filter.displayKey]).toLowerCase()),
      radio: (filter, item) => item[filter.displayKey] === filter.value,
    };
  }
})();
